import * as React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/system';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { RouterProvider } from 'react-router-dom';
import { register } from 'swiper/element/bundle';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';

import 'react-toastify/dist/ReactToastify.css';
import 'swiper/css';
import 'swiper/css/effect-cards';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/es';
import './index.css';
import './i18n';

import { useSession } from '@hooks';
import { getDeviceId } from '@utils';
import { lightTheme, darkTheme } from './theme/Theme';
import { buildRouter } from './routes';

export default function App() {
  const [useDefaultTheme, toggle] = React.useReducer((theme) => !theme, true);
  const { i18n } = useTranslation();
  const session = useSession();
  let theme = createTheme(useDefaultTheme ? darkTheme : lightTheme);
  theme = responsiveFontSizes(theme);
  register();

  const router = React.useMemo(() => buildRouter(session), [session]);

  React.useEffect(() => {
    getDeviceId().then((deviceId) => {
      if (!Capacitor.isNativePlatform()) {
        return;
      }

      // Hide splash screen on native platform
      SplashScreen.hide();
    });
  }, []);

  return (
    <HelmetProvider context={{}}>
      <GoogleReCaptchaProvider
        reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
        language={i18n.language}
      >
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ThemeProvider theme={theme}>
            {/* <InstallPWA /> */}
            {/* <PushNotificationManager /> */}
            <RouterProvider
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
              router={router}
            />
          </ThemeProvider>
        </LocalizationProvider>
      </GoogleReCaptchaProvider>
    </HelmetProvider>
  );
}
